import React from "react";
import { Card, Empty, List } from "antd";

const darkCardStyle = {
  borderRadius: 12,
  background: "#1f1f1f",
  color: "#fff",
  border: "1px solid #333",
  marginBottom: 12,
};

const CustomTag = ({ text, bgColor }) => (
  <div
    style={{
      backgroundColor: bgColor,
      color: "#fff",
      padding: "4px 12px",
      borderRadius: 8,
      fontSize: 13,
      fontWeight: 600,
    }}
  >
    {text}
  </div>
);

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const CustomerHistorySection = ({ history }) => {
  if (!history || history.length === 0) {
    return (
      <Card style={darkCardStyle} bordered={false}>
        <Empty
          description={
            <span style={{ color: "#fff" }}>
              Riwayat Pesanan tidak ditemukan
            </span>
          }
        />
      </Card>
    );
  }

  return (
    <List
      itemLayout="vertical"
      dataSource={history}
      renderItem={(item) => (
        <Card style={darkCardStyle} bordered={false}>
          {/* Tanggal & Nomor Pesanan */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 8,
            }}
          >
            <div style={{ fontSize: "13px", color: "#aaa" }}>
              {formatDate(item.TglTransaksi)} | No: {item.No}
            </div>

            <CustomTag
              bgColor={item.Bayar && item.Bayar > 0 ? "#52c41a" : "#ff4d4f"}
              text={
                item.Bayar > 0
                  ? `Bayar: Rp ${item.Bayar.toLocaleString("id-ID")}`
                  : "Tidak Bayar"
              }
            />
          </div>

          <span style={{ color: "#fff", fontSize: 14 }}>
            No. Resi : {item.NoResi ?? "-"}
          </span>
          {/* Subtotal */}
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              margin: "6px 0",
              color: "#4cafef",
            }}
          >
            Total Pesanan Seharga Rp {item.SubTotal.toLocaleString("id-ID")}
          </div>
          <p>{item.Pesanan}</p>

          {/* Info Tambahan */}
          <div style={{ fontSize: "13px", color: "#bbb" }}>
            📱 {item.NoHp} <br />
            👨‍💻 Admin: {item.NoAdmin}
          </div>
        </Card>
      )}
    />
  );
};

export default CustomerHistorySection;
